export enum ButtonSizeEnum {
    LG = "lg",
    MD = "md",
    SM = "sm",
}

export enum ButtonTypeEnum {
    BUTTON = "button",
    SUBMIT = "submit",
}

export enum ButtonVariantEnum {
    DANGER = "danger",
    GHOST = "ghost",
    GHOST_DANGER = "ghost-danger",
    LINK = "link",
    MUTED = "muted",
    PRIMARY = "primary",
}
